import {
  RecaptchaVerifier,
  signOut,
  updateProfile,
  PhoneAuthProvider,
  signInWithCredential,
  signInWithCustomToken
} from "firebase/auth";
import { auth } from "./firebase";
import { useEffect, useRef, useState } from "react";
import * as Sentry from "@sentry/react";
import { logout, refreshAccessToken } from "../redux/authentication/actions";

//invisible recaptcha verifier
export function reCaptchaVerifier() {
  if (
    typeof window !== "undefined" &&
    (window.Cypress || process.env.REACT_APP_STAGING === "local")
  ) {
    auth.settings.appVerificationDisabledForTesting = true;
  }

  return new RecaptchaVerifier(auth, "recaptcha-placeholder", {
    size: "invisible"
  });
}

export async function otpRequest(phoneNumber) {
  const appVerifier = window.reCaptchaVerifier;

  const authProvider = new PhoneAuthProvider(auth);
  return await authProvider.verifyPhoneNumber(phoneNumber, appVerifier);
}

export function getCurrentUser() {
  return auth.currentUser;
}

export async function otpValidate(loginOtp, verificationId) {
  return PhoneAuthProvider.credential(verificationId, loginOtp);
}

export async function signInWithAuthCredentials(authCredentials) {
  return await signInWithCredential(auth, authCredentials);
}

//SET USER DISPLAY NAME
export async function setDisplayName(userName) {
  const currentUser = getCurrentUser();
  let displayNames;
  try {
    displayNames =
      currentUser.displayName === null
        ? {}
        : JSON.parse(currentUser.displayName);
  } catch (error) {
    displayNames = {};
  }
  displayNames.patient = userName;
  await updateProfile(currentUser, {
    displayName: JSON.stringify(displayNames)
  });
  return displayNames;
}

//signup using auth credentials
export async function signUpWithAuthCredentials(authCredentials, userName) {
  const response = await signInWithCredential(auth, authCredentials);
  if (response.user.displayName === null) {
    const displayNames = {
      doctor: null,
      patient: userName,
      clinic: null
    };
    await updateProfile(response.user, {
      displayName: JSON.stringify(displayNames)
    });
  } else {
    let existingDisplayNames;
    try {
      existingDisplayNames = JSON.parse(response.user.displayName);
    } catch (error) {
      existingDisplayNames = {};
    }
    const displayNames = {
      ...existingDisplayNames,
      patient: userName
    };
    await updateProfile(response.user, {
      displayName: JSON.stringify(displayNames)
    });
  }
  return response;
}

export async function signInWithAuthCustomToken(customToken) {
  return await signInWithCustomToken(auth, customToken);
}

//auth subscriber
export function useAuthSubscriber() {
  const isAuth = useRef(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = auth.onIdTokenChanged(async (user) => {
      if (user) {
        const accessToken = await user.getIdToken();
        refreshAccessToken(accessToken);
        Sentry.setUser({
          id: user.uid,
          phoneNumber: user.phoneNumber
        });
        if (!isAuth.current) {
          isAuth.current = true;
        }
      } else {
        if (isAuth.current) {
          logout();
        }
        Sentry.setUser(null);
        isAuth.current = false;
      }

      setIsLoading(false);
    });

    return () => unsubscribe();
    // eslint-disable-next-line
  }, []);

  return { isLoggedIn: isAuth.current, isLoading };
}
//logout subscriber
export const logoutFromFirebase = async () => {
  await signOut(auth);
};
